import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import axios from '../../dataClient/dataClient'
import { billTypeMap } from '../../util/billingConsts'
import { BoldBodyText, BoldFormTitle, BoldSpan } from '../styles/Text'
import { FlexColumn, FlexEndContainer, PaddedForm, StyledDialog, StyledDialogContent } from '../styles/Containers'
import { ErrorMessage, SuccessMessage } from '../common/UserMessage'
import Button, { SecondaryButton } from '../common/Button'

function RefundBillPopUp({ billId, billType, secondaryId, amount, email, open = false, onClose = () => {}, onSuccess = () => {} }) {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(false)
  const [isCompleted, setIsCompleted] = useState(false)

  const billTypeLabel = billTypeMap[billType] || billType

  useEffect(() => {
    if (!open) return

    setError(false)
    setIsCompleted(false)
  }, [open])

  function onSubmit(e) {
    e.preventDefault()
    setIsLoading(true)
    setError(false)

    axios
      .post(`/bill/${billId}/refund`)
      .then(() => {
        setIsCompleted(true)
        onSuccess()
      })
      .catch(err => {
        console.error(`Failed to refund ${billTypeLabel.toLowerCase()}`, err)
        setError(true)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  return (
    <StyledDialog fullWidth open={open} onClose={onClose} keepMounted={false} aria-labelledby="refund-bill-pop-up">
      <StyledDialogContent>
        <PaddedForm onSubmit={onSubmit}>
          <FlexColumn gap="20px">
            <BoldFormTitle>Refund {billTypeLabel}</BoldFormTitle>

            {isCompleted ? (
              <FlexColumn gap="20px">
                <SuccessMessage>
                  {billTypeLabel} <BoldSpan>{secondaryId}</BoldSpan> successfully refunded.
                </SuccessMessage>
              </FlexColumn>
            ) : (
              <FlexColumn gap="20px">
                <BoldBodyText>
                  Are you sure you want to refund {billTypeLabel.toLowerCase()} <BoldSpan>{secondaryId}</BoldSpan> for{' '}
                  <BoldSpan>${amount.toFixed(2)}</BoldSpan> to <BoldSpan>{email}</BoldSpan>?
                </BoldBodyText>
                {error && <ErrorMessage>There was an error refunding the {billTypeLabel.toLowerCase()}. Please try again.</ErrorMessage>}
              </FlexColumn>
            )}

            <FlexEndContainer>
              {isCompleted ? (
                <SecondaryButton type="button" onClick={onClose}>
                  Close
                </SecondaryButton>
              ) : (
                <>
                  <SecondaryButton type="button" onClick={onClose} disabled={isLoading}>
                    Cancel
                  </SecondaryButton>
                  <Button type="submit" loading={isLoading}>
                    Confirm
                  </Button>
                </>
              )}
            </FlexEndContainer>
          </FlexColumn>
        </PaddedForm>
      </StyledDialogContent>
    </StyledDialog>
  )
}

RefundBillPopUp.propTypes = {
  billId: PropTypes.string.isRequired,
  billType: PropTypes.oneOf(['APPLICATION_FEE', 'FEE_ESTIMATE', 'INVOICE']).isRequired,
  secondaryId: PropTypes.string.isRequired,
  amount: PropTypes.number.isRequired,
  email: PropTypes.string.isRequired,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onSuccess: PropTypes.func
}

export default RefundBillPopUp
